import i18n, { Resource, ThirdPartyModule } from 'i18next'
import { observable, runInAction } from 'mobx'

import { Store } from '../general'
import { StorageKey, StorageStore } from '../storage'

import languageDetector from './detector'

export interface I18nConfig {
  module?: ThirdPartyModule
  resources?: Resource
}

interface RootStore {
  storage: StorageStore
}

class I18nStore extends Store<RootStore> {
  private _language = observable.box('en')
  private _availableLanguages: string[] = []

  get availableLanguages() {
    return this._availableLanguages
  }

  get language() {
    return this._language.get()
  }

  changeLanguage(language: string, persistent: boolean = true) {
    i18n.changeLanguage(language)
    if (persistent) {
      const { storage } = this.store
      storage?.set(StorageKey.Language, language)
    }
  }

  async init(config?: I18nConfig) {
    const { module, resources } = config || {}

    this._availableLanguages = Object.keys(resources || {})

    const { storage } = this.store
    storage?.get(StorageKey.Language, undefined, async (lng) => {
      i18n.on('languageChanged', (language) => {
        runInAction(() => {
          console.debug('I18N: Language: ', language)
          this._language.set(language)
        })
      })
      const i18nWithLanguage = i18n.use(languageDetector) // Custom language detector
      const i18nWithModule = module ? i18nWithLanguage.use(module) : i18nWithLanguage // passes i18n down to react-i18next
      await i18nWithModule.init({
        debug: false, //!process.env.NODE_ENV || process.env.NODE_ENV === 'development',
        nsSeparator: false,
        keySeparator: false,
        interpolation: {
          escapeValue: false, // not needed for react as it escapes by default
        },
        resources,
        lng,
      })
    })
  }
}

export default I18nStore
